<template>
    <living-box-component :active="!$_.isEmpty(active)" v-on:update:active="closePost" v-on:update:full-screen="setFullScreen(!fullScreen)" :full-screen="fullScreen" >
        <template v-slot:main>
            <scroll-hide-nav @handle-scroll="handleScroll($event)">
                <div class="max-w-content">
                    <tag-search-list :tags="tags" :active-tags="activeTags" @click="handleTagClick" @search="handleSearch"></tag-search-list>
                    <posts-list v-if="posts.length" :posts="posts" :key="activeTags.length"></posts-list>
                    
                    <div class="service-message" v-if="!posts.length && !loading">
                      <p>Результаты не найдены</p>
                    </div>
                  
                    <pre-loader-component :visible="!firstLoading && loading" :small="true"></pre-loader-component>
                </div>
                <pre-loader-component :visible="firstLoading"></pre-loader-component>
            </scroll-hide-nav>
        </template>
        <template v-slot:leaving>
            <active-post v-show="!$_.isEmpty(active)" :post="active"></active-post>
        </template>
    </living-box-component>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
    import TagSearchList from "../common/TagSearchList";
    import ActivePost from "./ActivePost";
    import PostsList from "./PostsList";
    import PreLoaderComponent from "../common/PreLoader";
    import LivingBoxComponent from "../common/LivingBoxComponent";
    import ScrollHideNav from "../common/ScrollHideNav";


    export default {
        name: 'knowledge-base-component-box',
        components: {
            ScrollHideNav,
            LivingBoxComponent,
            PreLoaderComponent,
            PostsList,
            TagSearchList,
            ActivePost,
        },
        computed: {
            ...mapState({
                posts: state => state.knowledge.posts,
                loading: state => state.knowledge.loading,
                fullScreen: state => state.knowledge.fullScreen,
                active: state => state.knowledge.activePost,
                tags: state => state.knowledge.tags,
                activeTags: state => state.knowledge.activeTags,
                search: state => state.knowledge.search,
            }),
            ...mapGetters('knowledge', [
                'getTagsIds'
            ]),
            postsListRows() {
                return Math.round(this.posts.length / 2);
            },
            firstLoading() {
                return this.loading && !this.posts.length
            }
        },
        methods: {
            ...mapActions('knowledge', [
                'getPost',
                'closeActivePost',
                'getMorePosts',
                'getAllPosts',
                'getAllTags',
                'setActiveTag',
                'setActiveTags',
                'setSearchQuery',
            ]),
            ...mapActions([
                'visibleNav'

            ]),
            ...mapMutations('knowledge', [
                'setFullScreen',
                'setActivePost',
            ]),
            ...mapMutations([
                'setNavVisible',
            ]),
            closePost() {
                this.closeActivePost();
                this.$router.push({ name: 'knowledge-base', query: this.$route.query})
            },
            switchPost () {
                this.setFullScreen(!this.fullScreen);
            },
            handleScroll(vertical) {
                this.currentScrollPosition = vertical.scrollTop;
                if (vertical.process >= 0.97 && !this.loading) {
                    this.getMorePosts()
                }
            },
            handleTagClick(id) {
                this.setActiveTag(id);
            },
            handleSearch(searchString) {
              this.setSearchQuery(searchString);
            }
        },
        created() {
            this.$store.commit('setAppClass', 'knowledge-base-component');
            this.getAllTags().then(() => {
                console.log(this.$route.name);
                let revision = this.$route.name === 'knowledge-base-archive';
                let postId = this.$route.params.id;
                if (postId) {
                    this.getPost({id: postId, revision: revision});
                    this.setNavVisible(false)
                }
                let tags = this.$route.query.tag;
                if (tags) {
                    tags = this.$_.concat(tags);
                    this.setActiveTags(tags)
                }
                let search = this.$route.query.search;
                if (search) {
                  search = this.$_.concat(search);
                  this.setSearchQuery(search)
                }
                this.getAllPosts();
            });
        },
        destroyed() {
            this.setActiveTags([])
        },
        beforeRouteUpdate (to, from, next) {
            if(!to.params.id) {
                this.setActivePost({})
            } else {
                let revision = to.name === 'knowledge-base-archive';
                this.getPost({id: to.params.id, revision: revision});
                this.setNavVisible(false)
            }
            next()
        },
    }
</script>


<style scoped>
.service-message{
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5em;
  color: #A6AAB4;
  max-width: 620px;
  margin: 0 0 40px;
}
.service-message p{
  margin: 0;
}

</style>
